export default __webpack_public_path__ + "static/media/powerPoint.ad8435b5.svg";